/**
 * Brazilian Portuguese (pt-BR) mappings for DefaultMobileBanner
 */

export const defaultMobileBannerPtBR = {
  // Page titles
  "PICKSTAR": "PICKSTAR",
  "SPORTS": "ESPORTES",
  "MARKET": "MERCADO",
  "CHAT": "CONVERSA",
  "UPGRADE": "ATUALIZAR",
  "ADMIN": "ADMIN",

  // Authentication
  "Login": "Entrar",

  // Additional page names that might appear
  "SETTINGS": "CONFIGURAÇÕES",
  "HELP": "AJUDA",
  "ABOUT": "SOBRE",
  "PROFILE": "PERFIL",
  "HISTORY": "HISTÓRICO",
};